export default __webpack_public_path__ + "static/ASLA_Tenza_2a-ce19bbcc38360f6f78e41e95d1e2a1b9.png";